function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import camelCase from 'lodash/camelCase';
import { AppContext } from 'context';
import history from 'helpers/history';
import ChevronRight from 'svg/chevron-right.svg';
import Chip from 'components/Chip';
import Button from 'components/Form/Button';
import Tabs from 'components/Tabs';
import App from 'modules/App';
import Account from 'modules/Account';
import { SCOPE_NAMES } from 'modules/Account/constants';
import * as actions from '../../actions';
import * as shapes from '../../shapes';
import messages from '../../messages';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import EnableCountryModal from './EnableCountryModal';
import UnitsOfMeasurements from './tabs/UnitsOfMeasurements';
import General from './tabs/General';
import GlucoseRanges from './tabs/GlucoseRanges';
import Payers from './tabs/Payers';
import Identifiers from './tabs/Identifiers';
import Meters from './tabs/Meters';
import styles from './ConfigureCountry.pcss';
var _React_Component;
class ConfigureCountry extends (_React_Component = React.Component) {
    componentDidMount() {
        this.props.onFetchCountry(this.props.countryCode);
        this.props.onFetchCountryConfiguration(this.props.countryCode);
        this.props.onFetchLanguages();
        this.props.onFetchDevices();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isSendCountryConfigurationAnyTabInProgress && !this.props.isSendCountryConfigurationAnyTabInProgress) {
            this.props.onFetchCountryConfiguration(this.props.countryCode);
            this.handleHasUnsavedChangesChanged(false);
        }
        if (prevProps.isEnableCountryProgress && !this.props.isEnableCountryProgress && !this.props.enableCountryErrors) {
            this.props.onFetchCountry(this.props.countryCode);
        }
        if (prevProps.isFetchInProgress && !this.props.isFetchInProgress) {
            this.onInit();
        }
    }
    onInit() {
        this.setState({
            isLoaded: true
        });
    }
    onTabClick(activeViewKey) {
        this.setState({
            activeViewKey
        });
    }
    onBackButtonClick() {
        history.push(this.context.getUrl('countries'));
    }
    onEnableCountry() {
        this.props.onOpenEnableCountryModal();
    }
    get views() {
        return {
            General,
            UnitsOfMeasurements,
            GlucoseRanges,
            Payers,
            Identifiers,
            Meters
        };
    }
    get viewKeysOrder() {
        return [
            'General',
            'UnitsOfMeasurements',
            'GlucoseRanges',
            'Payers',
            'Identifiers',
            'Meters'
        ];
    }
    get tabsLabels() {
        return this.viewKeysOrder.map((id)=>({
                id,
                message: messages.tabs.configureCountry[camelCase(id)]
            })).reduce((prev, current)=>_object_spread_props(_object_spread({}, prev), {
                [current.id]: current.message
            }), {});
    }
    renderSwitchCountryIsActiveButton() {
        const { isActive } = this.props.country;
        const { isSDNAdmin } = this.props;
        if (isActive) {
            return /*#__PURE__*/ _jsx(Chip, {
                className: "ml-6",
                labelMessage: messages.labels.countryEnabled,
                styleModifier: "success"
            });
        }
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Chip, {
                    className: "ml-6",
                    labelMessage: messages.labels.countryDisabled,
                    styleModifier: "error"
                }),
                isSDNAdmin ? /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    styleModifier: "primary",
                    labelMessage: messages.buttons.enableCountry,
                    className: cn('btn mr-0 ml-auto', {
                        'btn--filled': !isActive
                    }),
                    isInProgress: this.props.isEnableCountryProgress,
                    isDisabled: this.props.isNavigationBlocked,
                    titleMessage: this.props.isNavigationBlocked ? App.messages.infos.unsavedConfiguration : null,
                    onClick: ()=>this.onEnableCountry()
                }) : null
            ]
        });
    }
    renderHeader() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.configureCountry__header,
            children: [
                /*#__PURE__*/ _jsxs(Button, {
                    type: "button",
                    onClick: ()=>this.onBackButtonClick(),
                    children: [
                        /*#__PURE__*/ _jsx(ChevronRight, {
                            className: "backArrow"
                        }),
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.backToListCountries))
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsxs("header", {
                            className: "text--h1",
                            children: [
                                " ",
                                this.props.country.englishName
                            ]
                        }),
                        this.renderSwitchCountryIsActiveButton()
                    ]
                })
            ]
        });
    }
    renderTabs() {
        return /*#__PURE__*/ _jsx(Tabs, {
            activeItem: this.state.activeViewKey,
            items: this.viewKeysOrder,
            messages: this.tabsLabels,
            action: (activeViewKey)=>this.onTabClick(activeViewKey)
        });
    }
    renderContent() {
        const ActiveView = this.views[this.state.activeViewKey];
        return /*#__PURE__*/ _jsxs("div", {
            className: "card card--mainContent justify-content-between",
            children: [
                this.renderTabs(),
                /*#__PURE__*/ _jsx(ActiveView, {
                    countryCode: this.props.country.code,
                    ref: this.myRef,
                    onHasUnsavedChangesChanged: this.handleHasUnsavedChangesChanged,
                    isFetchInProgress: this.props.isFetchInProgress
                })
            ]
        });
    }
    renderModals() {
        if (this.props.openModalId === constants.ENABLE_COUNTRY_MODAL) {
            return /*#__PURE__*/ _jsx(EnableCountryModal, {
                country: this.props.country
            });
        }
        return null;
    }
    render() {
        if (!this.state.isLoaded || !this.props.country) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.configureCountry,
            children: [
                this.renderHeader(),
                this.renderContent(),
                this.renderModals()
            ]
        });
    }
    constructor(props){
        super(props), _define_property(this, "handleHasUnsavedChangesChanged", (hasUnsavedChanges)=>{
            const { isNavigationBlocked } = this.props;
            if (hasUnsavedChanges) {
                if (!isNavigationBlocked) this.props.onBlockNavigation();
            } else if (isNavigationBlocked) this.props.onUnblockNavigation();
        });
        this.state = {
            activeViewKey: this.viewKeysOrder[0],
            isLoaded: false
        };
    }
}
_define_property(ConfigureCountry, "contextType", AppContext);
_define_property(ConfigureCountry, "propTypes", {
    // Explicit props
    countryCode: PropTypes.string.isRequired,
    // Implicit props
    country: shapes.country,
    enableCountryErrors: PropTypes.array,
    openModalId: PropTypes.string,
    isFetchInProgress: PropTypes.bool,
    isSendCountryConfigurationAnyTabInProgress: PropTypes.bool,
    isEnableCountryProgress: PropTypes.bool,
    isSDNAdmin: PropTypes.bool,
    isNavigationBlocked: PropTypes.bool,
    // Implicit actions
    onFetchCountry: PropTypes.func,
    onFetchCountryConfiguration: PropTypes.func,
    onFetchLanguages: PropTypes.func,
    onFetchDevices: PropTypes.func,
    onBlockNavigation: PropTypes.func,
    onUnblockNavigation: PropTypes.func,
    onOpenUnsavedChangesModal: PropTypes.func,
    onOpenEnableCountryModal: PropTypes.func,
    onCloseModal: PropTypes.func
});
const mapStateToProps = (state)=>({
        country: selectors.configuredCountry(state),
        isFetchInProgress: selectors.isFetchCountryInProgress(state) || selectors.isFetchCountryConfigurationInProgress(state) || selectors.isFetchLanguagesInProgress(state),
        isSDNAdmin: Account.selectors.scope(state) === SCOPE_NAMES.SDN_ADMIN,
        isSendCountryConfigurationAnyTabInProgress: selectors.isSendCountryConfigurationAnyTabInProgress(state),
        isEnableCountryProgress: selectors.isEnableCountryProgress(state),
        enableCountryErrors: selectors.enableCountryErrors(state),
        openModalId: App.selectors.modal(state),
        isNavigationBlocked: App.selectors.isNavigationBlocked(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onFetchCountry: (countryCode)=>dispatch(actions.fetchCountry(countryCode)),
        onFetchCountryConfiguration: (countryCode)=>dispatch(actions.fetchCountryConfiguration(countryCode)),
        onFetchLanguages: (countryCode)=>dispatch(actions.fetchLanguages(countryCode)),
        onFetchDevices: (countryCode)=>dispatch(App.actions.fetchDevices(countryCode)),
        onBlockNavigation: ()=>dispatch(App.actions.blockNavigation()),
        onUnblockNavigation: ()=>dispatch(App.actions.unblockNavigation()),
        onOpenUnsavedChangesModal: ()=>dispatch(App.actions.openModal(App.constants.UNSAVED_CHANGES_MODAL)),
        onOpenEnableCountryModal: ()=>dispatch(App.actions.openModal(constants.ENABLE_COUNTRY_MODAL)),
        onCloseModal: ()=>dispatch(App.actions.closeModal())
    });
const ConnectedConfigureCountry = connect(mapStateToProps, mapDispatchToProps)(ConfigureCountry);
export default withStyles(styles)(ConnectedConfigureCountry);
